import React from "react";
import IOrder from "../../../models/IOrder";
import ISupplierModel from "../../../models/ISupplierModel";
import OrderStatesEnum from "../../../models/OrderStatesEnum";
import "./OrderProgressTrackerItemShipped.scss";
import OrderSourceEnum from "../../../models/OrderSourceEnum";

type Props = {
    supplierModel: ISupplierModel;
    order: Partial<IOrder>;
    getChevron: (isSelected: boolean) => any;
    getStepMarker: (title: string, isSelected?: boolean, showTitleOnMobile?: boolean) => any;
};

export const OrderProgressTrackerItemShipped: React.FC<Props> = (props) => {
    const partiallyShippedSelected = props.order.order_state_id === OrderStatesEnum.PARTIALLY_SHIPPED;
    let shippedSelected = props.order.order_state_id === OrderStatesEnum.SHIPPED;

    let readyForPickupSelected = props.order.order_state_id === OrderStatesEnum.READY_FOR_PICKUP;
    const pickedUpSelected = props.order.order_state_id === OrderStatesEnum.PICKED_UP;

    let readyForDeliverySelected = props.order.order_state_id === OrderStatesEnum.READY_FOR_DELIVERY;
    const deliveredSelected = props.order.order_state_id === OrderStatesEnum.DELIVERED;

    if (pickedUpSelected) {
        readyForPickupSelected = true;
    }

    if (deliveredSelected) {
        readyForDeliverySelected = true;
    }

    const orderIsLocalDelivery = !!props.order.is_local_delivery;
    const orderIsLocalPickup = !!props.order.is_local_pickup;

    if (!orderIsLocalDelivery && !orderIsLocalPickup) {
        if (props.supplierModel.order_progress_states) {
            const finalStep = props.supplierModel.order_progress_states.find((state) => state.isFinalStep);
            if (finalStep) {
                if (props.order.order_state_id === finalStep.order_state_id) {
                    shippedSelected = true;
                }
            }
        }
    }

    let hideDelivery = false;
    let hidePickup = false;

    switch (props.order.order_source_id) {
        case OrderSourceEnum.WAYFAIR:
            hideDelivery = true;
            hidePickup = true;
            break;
    }

    return (
        <div className={"OrderProgressTrackerItemShipped d-flex align-items-center"}>
            {readyForPickupSelected || readyForDeliverySelected || orderIsLocalDelivery || orderIsLocalPickup ? null : (
                <div className={"shipped"}>
                    {partiallyShippedSelected ? (
                        <>
                            {props.getChevron(partiallyShippedSelected)}
                            {props.getStepMarker("partially_shipped", partiallyShippedSelected, true)}
                        </>
                    ) : (
                        <>
                            {props.getChevron(shippedSelected)}
                            {props.getStepMarker("shipped", shippedSelected, true)}
                        </>
                    )}
                </div>
            )}

            {orderIsLocalDelivery || hideDelivery ? null : props.supplierModel.has_local_pickup &&
              !shippedSelected &&
              !partiallyShippedSelected &&
              !readyForDeliverySelected &&
              orderIsLocalPickup ? (
                <div className={"local-delivery d-flex align-items-center"}>
                    <div className="d-flex align-items-center">
                        {props.getChevron(readyForPickupSelected)}
                        {props.getStepMarker("ready_for_pickup", readyForPickupSelected, true)}
                    </div>
                    <div className="d-flex align-items-center">
                        {props.getChevron(pickedUpSelected)}
                        {props.getStepMarker("picked_up", pickedUpSelected, true)}
                    </div>
                </div>
            ) : null}

            {orderIsLocalPickup || hidePickup ? null : props.supplierModel.has_local_delivery &&
              !shippedSelected &&
              !partiallyShippedSelected &&
              !readyForPickupSelected &&
              orderIsLocalDelivery ? (
                <div className={"local-delivery d-flex align-items-center"}>
                    <div className="d-flex align-items-center">
                        {props.getChevron(readyForDeliverySelected)}
                        {props.getStepMarker("ready_for_delivery", readyForDeliverySelected, true)}
                    </div>
                    <div className="d-flex align-items-center">
                        {props.getChevron(deliveredSelected)}
                        {props.getStepMarker("delivered", deliveredSelected, true)}
                    </div>
                </div>
            ) : null}
        </div>
    );
};
